/**
 * D1 Store Locator — Google Maps JS API, geocoding, list + search.
 */
(function () {
  'use strict';

  var MAPS_CALLBACK = 'd1StoreLocatorMapsReady';
  var loadPromise = null;

  function getJson(root) {
    var el = root.querySelector('script.d1-store-locator__data[type="application/json"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function loadMapsApi(key) {
    if (window.google && window.google.maps) {
      if (window.google.maps.places) {
        return Promise.resolve();
      }
      if (loadPromise) {
        return loadPromise;
      }
      if (typeof google.maps.importLibrary === 'function') {
        loadPromise = google.maps
          .importLibrary('places')
          .then(function () {
            return;
          })
          .catch(function () {
            loadPromise = null;
            return;
          });
        return loadPromise;
      }
      return Promise.resolve();
    }
    if (loadPromise) {
      return loadPromise;
    }
    loadPromise = new Promise(function (resolve, reject) {
      if (!key) {
        reject(new Error('Missing Maps API key'));
        return;
      }
      if (window[MAPS_CALLBACK]) {
        delete window[MAPS_CALLBACK];
      }
      window[MAPS_CALLBACK] = function () {
        delete window[MAPS_CALLBACK];
        resolve();
      };
      var s = document.createElement('script');
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(key) +
        '&libraries=places&callback=' +
        MAPS_CALLBACK;
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        delete window[MAPS_CALLBACK];
        loadPromise = null;
        reject(new Error('Failed to load Google Maps'));
      };
      document.head.appendChild(s);
    });
    return loadPromise;
  }

  function escapeHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function telHref(phone) {
    if (phone == null || phone === '') return '';
    return 'tel:' + String(phone).replace(/[\s()]/g, '');
  }

  /**
   * Preset Google Maps style arrays. Custom JSON in the section overrides these.
   */
  /**
   * Water near-black, land mid-grey, blue roads. No global geometry rule (that washed out land vs sea).
   * Markers use google.maps.Symbol (reliable) not SVG data-URLs. Pins use the section accent in JS.
   */
  var MAP_STYLES_D1_BRAND = [
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#060608' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#5a6a72' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#4a4a50' }] },
    { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#45454c' }] },
    { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#4d4d54' }] },
    { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#3d3d44' }] },
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#c4c4c4' }] },
    { featureType: 'administrative', elementType: 'labels.text.stroke', stylers: [{ color: '#2a2a2e' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#3a3a40' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#8e8e96' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#3a423a' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#b0b0b5' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#2c2c30' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#1a4a7a' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#2563a8' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9ec5f2' }] },
    { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#1a4a7a' }] },
    { featureType: 'road.arterial', elementType: 'geometry.stroke', stylers: [{ color: '#2b6ab8' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#1989E5' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#5eb0f2' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#e3f0ff' }] },
    { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#153a5c' }] },
    { featureType: 'road.local', elementType: 'geometry.stroke', stylers: [{ color: '#1a4a7a' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  ];

  var MAP_STYLES_D1_LIGHT = [
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#b8d9f0' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#e8e9e4' }] },
    { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#e4e4e0' }] },
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#c9d6c0' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#d6d6d2' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e8e8e2' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#c4c4be' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#5c5c5a' }] },
  ];

  var MAP_STYLES_LIGHT_MINIMAL = [
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f3' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#dde8f0' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#e0e0de' }] },
  ];

  var MAP_STYLES_SILVER = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
  ];

  function resolveMapStyles(data) {
    if (!data) return null;
    var custom = data.mapStylesJson;
    if (custom && String(custom).trim()) {
      try {
        var parsed = JSON.parse(String(custom));
        if (Array.isArray(parsed) && parsed.length) {
          return parsed;
        }
      } catch (e) {
        /* fall back to preset */
      }
    }
    var key = data.mapStyle;
    if (!key || key === 'default') {
      return null;
    }
    if (key === 'd1_brand') {
      return MAP_STYLES_D1_BRAND;
    }
    if (key === 'd1_light') {
      return MAP_STYLES_D1_LIGHT;
    }
    if (key === 'light_minimal') {
      return MAP_STYLES_LIGHT_MINIMAL;
    }
    if (key === 'silver') {
      return MAP_STYLES_SILVER;
    }
    return null;
  }

  function getSectionAccentColor(root) {
    if (!root) {
      return '#1989E5';
    }
    var c = (getComputedStyle(root).getPropertyValue('--d1-sl-accent') || '').trim();
    if (c) {
      return c;
    }
    return '#1989E5';
  }

  /**
   * Vector symbol — Google often fails to draw SVG data-URL marker icons. Symbol always renders.
   */
  function makeAccentMarkerSymbol(google, accent) {
    var fill = (accent || '#1989E5').trim() || '#1989E5';
    return {
      path: google.SymbolPath.CIRCLE,
      fillColor: fill,
      fillOpacity: 1,
      strokeColor: '#ffffff',
      strokeWeight: 2.5,
      scale: 12,
    };
  }

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  /** @returns {number} distance in km */
  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  var GEOCODE_TIMEOUT_MS = 6000;

  function geocodeLocation(geocoder, loc) {
    return new Promise(function (resolve) {
      if (loc.lat != null && loc.lng != null && loc.lat !== '' && loc.lng !== '') {
        var latN = parseFloat(String(loc.lat), 10);
        var lngN = parseFloat(String(loc.lng), 10);
        if (Number.isFinite(latN) && Number.isFinite(lngN)) {
          resolve({ loc: loc, position: { lat: latN, lng: lngN } });
          return;
        }
      }
      if (!loc.address) {
        resolve({ loc: loc, position: null });
        return;
      }
      var settled = false;
      var finish = function (position) {
        if (settled) return;
        settled = true;
        resolve({ loc: loc, position: position });
      };
      // ponytail: Geocoder sometimes never calls back (API disabled / key) — don't block the map forever
      var timer = setTimeout(function () {
        finish(null);
      }, GEOCODE_TIMEOUT_MS);
      try {
        geocoder.geocode(
          { address: String(loc.address) + ', Australia', region: 'au' },
          function (results, status) {
            clearTimeout(timer);
            if (status === 'OK' && results && results[0]) {
              finish(results[0].geometry.location);
            } else {
              finish(null);
            }
          }
        );
      } catch (e) {
        clearTimeout(timer);
        finish(null);
      }
    });
  }

  /**
   * Geocode user search (suburb, postcode, address). Bias to Australia.
   * @param {(outcome: 'ok'|'notfound'|'error', result: {lat: number, lng: number} | null) => void} done
   */
  function geocodeUserSearch(geocoder, q, done) {
    var query = String(q).trim() + ', Australia';
    geocoder.geocode({ address: query }, function (results, status) {
      if (status === 'OK' && results[0] && results[0].geometry && results[0].geometry.location) {
        var p = results[0].geometry.location;
        var lat = typeof p.lat === 'function' ? p.lat() : p.lat;
        var lng = typeof p.lng === 'function' ? p.lng() : p.lng;
        done('ok', { lat: lat, lng: lng });
        return;
      }
      if (status === 'ZERO_RESULTS' || status === 'INVALID_REQUEST') {
        done('notfound', null);
        return;
      }
      done('error', null);
    });
  }

  function setSearchHint(hintEl, show, text, tone) {
    if (!hintEl) return;
    if (!show || !text) {
      hintEl.textContent = '';
      hintEl.hidden = true;
      hintEl.removeAttribute('data-tone');
      return;
    }
    hintEl.textContent = text;
    hintEl.hidden = false;
    if (tone) {
      hintEl.setAttribute('data-tone', tone);
    } else {
      hintEl.removeAttribute('data-tone');
    }
  }

  function setRowDistanceLine(row, km) {
    var main = row.querySelector('.d1-store-locator__item-main');
    if (!main) return;
    var el = main.querySelector('.d1-store-locator__item-distance');
    if (km == null || row.hidden) {
      if (el) {
        el.remove();
      }
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = 'd1-store-locator__item-distance';
      var phone = main.querySelector('.d1-store-locator__item-phone');
      if (phone) {
        main.insertBefore(el, phone);
      } else {
        var addr = main.querySelector('.d1-store-locator__item-address');
        if (addr) {
          main.insertBefore(el, addr.nextSibling);
        } else {
          var title = main.querySelector('.d1-store-locator__item-title');
          if (title) {
            main.insertBefore(el, title.nextSibling);
          } else {
            main.appendChild(el);
          }
        }
      }
    }
    if (km < 1) {
      el.textContent = 'Approx. ' + Math.round(km * 1000) + ' m away';
    } else if (km < 10) {
      el.textContent = 'Approx. ' + km.toFixed(1) + ' km away';
    } else {
      el.textContent = 'Approx. ' + Math.round(km) + ' km away';
    }
  }

  function clearAllDistanceLines(listEl) {
    if (!listEl) return;
    [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item-distance'), function (el) {
      el.remove();
    });
    [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item'), function (row) {
      row.removeAttribute('data-distance-km');
    });
  }

  function restoreListOrderFromInitial(listEl) {
    if (!listEl) return;
    var items = [].slice.call(listEl.querySelectorAll('.d1-store-locator__item'));
    items.sort(function (a, b) {
      return (
        parseInt(a.getAttribute('data-initial-index') || '0', 10) -
        parseInt(b.getAttribute('data-initial-index') || '0', 10)
      );
    });
    items.forEach(function (el) {
      listEl.appendChild(el);
    });
  }

  function sortListByProximity(listEl) {
    if (!listEl) return;
    var all = [].slice.call(listEl.querySelectorAll('.d1-store-locator__item'));
    var visible = all.filter(function (r) {
      return !r.hidden;
    });
    var hidden = all.filter(function (r) {
      return r.hidden;
    });
    visible.sort(function (a, b) {
      return (
        parseFloat(a.getAttribute('data-distance-km') || '999999') -
        parseFloat(b.getAttribute('data-distance-km') || '999999')
      );
    });
    visible.forEach(function (el) {
      listEl.appendChild(el);
    });
    hidden.forEach(function (el) {
      listEl.appendChild(el);
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-d1-sl-initialized') === 'true') {
      return;
    }
    var data = getJson(root);
    if (!data || !data.locations) {
      return;
    }

    var mapEl = root.querySelector('[data-d1-sl-map]');
    var listEl = root.querySelector('[data-d1-sl-list]');
    var searchEl = root.querySelector('[data-d1-sl-search]');
    var countEl = root.querySelector('[data-d1-sl-count]');
    var hintEl = root.querySelector('[data-d1-sl-search-hint]');
    var emptyEl = root.querySelector('[data-d1-sl-empty]');
    var filterRoot = root.querySelector('[data-d1-sl-filters]');
    if (!mapEl) return;

    if (data.locations.length === 0) {
      mapEl.setAttribute('data-state', 'empty');
      return;
    }

    root.setAttribute('data-d1-sl-initialized', 'true');

    var messages = data.messages && typeof data.messages === 'object' ? data.messages : {};
    var MIN_GEO_CHARS = 3;

    var ctx = {
      map: null,
      markers: null,
      infoWindows: null,
      geocoder: null,
      idToLatLng: {},
      userOrigin: null,
      searchGeocodeOutcome: null,
      searchDebounce: null,
      _skipInputReset: false,
    };

    function hasStoreGeoIndex() {
      return ctx.idToLatLng && Object.keys(ctx.idToLatLng).length > 0;
    }

    function getMaxDistanceKm() {
      var raw = data.maxDistanceKm;
      if (raw == null || raw === '') {
        return 200;
      }
      var n = parseInt(String(raw), 10);
      if (isNaN(n) || n < 0) {
        return 200;
      }
      return n === 0 ? Infinity : n;
    }

    function applyFilters(refitToVisible) {
      var q = (searchEl && (searchEl.value || '').trim()) || '';
      var qLower = q.toLowerCase();
      var stateFilter = 'all';
      if (filterRoot) {
        var activeBtn = filterRoot.querySelector('button[data-d1-sl-filter][data-active="true"]');
        if (activeBtn) {
          var af = activeBtn.getAttribute('data-d1-sl-filter');
          if (af) {
            stateFilter = af;
          }
        }
      }
      if (!listEl) {
        return;
      }

      clearAllDistanceLines(listEl);

      var useGeoSearch = q.length >= MIN_GEO_CHARS && hasStoreGeoIndex();
      var maxKm = getMaxDistanceKm();
      var visible = 0;
      var geoOk = useGeoSearch && ctx.userOrigin && ctx.searchGeocodeOutcome === 'ok';

      [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item'), function (row) {
        var s = row.getAttribute('data-state') || '';
        var t = (row.getAttribute('data-search') || '').toLowerCase();
        var id = row.getAttribute('data-id');
        var p = ctx.idToLatLng[id];
        var stateOk = stateFilter === 'all' || s === stateFilter;
        var show = false;

        if (!q) {
          show = stateOk;
        } else if (useGeoSearch) {
          if (geoOk && p) {
            var dist = haversineKm(ctx.userOrigin.lat, ctx.userOrigin.lng, p.lat, p.lng);
            row.setAttribute('data-distance-km', String(dist));
            show = stateOk && dist <= maxKm;
          } else if (geoOk && !p) {
            row.removeAttribute('data-distance-km');
            show = false;
          } else {
            row.removeAttribute('data-distance-km');
            show = stateOk;
          }
        } else {
          row.removeAttribute('data-distance-km');
          show = stateOk && t.indexOf(qLower) !== -1;
        }

        if (show) {
          row.hidden = false;
          visible++;
        } else {
          row.hidden = true;
          row.removeAttribute('data-active');
        }
      });

      if (geoOk) {
        [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item'), function (row) {
          if (row.hidden) {
            return;
          }
          var id = row.getAttribute('data-id');
          var p = ctx.idToLatLng[id];
          if (!p) {
            return;
          }
          var d = row.getAttribute('data-distance-km');
          if (d == null) {
            return;
          }
          setRowDistanceLine(row, parseFloat(String(d), 10));
        });
        sortListByProximity(listEl);
        if (visible > 0) {
          setSearchHint(hintEl, true, messages.searchSorted || '', false);
        } else {
          setSearchHint(hintEl, false, '', null);
        }
      } else if (useGeoSearch && ctx.searchGeocodeOutcome === 'notfound') {
        setSearchHint(hintEl, true, messages.placeNotFound || '', 'error');
      } else if (useGeoSearch && ctx.searchGeocodeOutcome === 'error') {
        setSearchHint(hintEl, true, messages.lookupFailed || '', 'error');
      } else {
        setSearchHint(hintEl, false, '', null);
        if (!q || !useGeoSearch) {
          restoreListOrderFromInitial(listEl);
        }
      }

      if (countEl) {
        countEl.textContent = String(visible);
      }

      if (emptyEl) {
        var hasStores = data.locations && data.locations.length > 0;
        emptyEl.hidden = !(visible === 0 && hasStores);
      }

      if (ctx.map && ctx.markers) {
        ctx.markers.forEach(function (m) {
          var s = m.loc.state || '';
          var t =
            (m.loc.title || '') +
            ' ' +
            (m.loc.address || '') +
            ' ' +
            (m.loc.phone || '') +
            ' ' +
            s;
          t = t.toLowerCase();
          var stateOk = stateFilter === 'all' || s === stateFilter;
          var p = ctx.idToLatLng[m.id];
          var searchOk;
          if (!q) {
            searchOk = true;
          } else if (useGeoSearch) {
            if (geoOk && p) {
              var distM = haversineKm(
                ctx.userOrigin.lat,
                ctx.userOrigin.lng,
                p.lat,
                p.lng
              );
              searchOk = stateOk && distM <= maxKm;
            } else if (geoOk && !p) {
              searchOk = false;
            } else {
              searchOk = stateOk;
            }
          } else {
            searchOk = t.indexOf(qLower) !== -1;
          }
          m.marker.setMap(stateOk && searchOk ? ctx.map : null);
        });
        if (refitToVisible) {
          var b = new google.maps.LatLngBounds();
          var any = false;
          ctx.markers.forEach(function (m) {
            if (m.marker.getMap()) {
              b.extend(m.marker.getPosition());
              any = true;
            }
          });
          if (any && !b.isEmpty()) {
            ctx.map.fitBounds(b, { padding: 80 });
          }
        }
      }
    }

    function scheduleSearchGeocode() {
      clearTimeout(ctx.searchDebounce);
      var q = (searchEl && (searchEl.value || '').trim()) || '';
      if (q.length < MIN_GEO_CHARS || !ctx.geocoder) {
        return;
      }
      var runFor = q;
      ctx.searchDebounce = setTimeout(function () {
        var qNow = (searchEl && (searchEl.value || '').trim()) || '';
        if (qNow.length < MIN_GEO_CHARS || qNow !== runFor) {
          return;
        }
        geocodeUserSearch(ctx.geocoder, qNow, function (outcome, result) {
          if ((searchEl && (searchEl.value || '').trim()) !== qNow) {
            return;
          }
          if (outcome === 'ok' && result) {
            ctx.userOrigin = result;
            ctx.searchGeocodeOutcome = 'ok';
          } else if (outcome === 'notfound') {
            ctx.userOrigin = null;
            ctx.searchGeocodeOutcome = 'notfound';
          } else {
            ctx.userOrigin = null;
            ctx.searchGeocodeOutcome = 'error';
          }
          applyFilters(true);
        });
      }, 420);
    }

    function onSearchInput() {
      if (ctx._skipInputReset) {
        ctx._skipInputReset = false;
        return;
      }
      clearTimeout(ctx.searchDebounce);
      var q = (searchEl && (searchEl.value || '').trim()) || '';
      if (!q) {
        ctx.userOrigin = null;
        ctx.searchGeocodeOutcome = null;
        clearAllDistanceLines(listEl);
        setSearchHint(hintEl, false, '', null);
        restoreListOrderFromInitial(listEl);
        applyFilters(false);
        return;
      }
      if (q.length < MIN_GEO_CHARS) {
        ctx.userOrigin = null;
        ctx.searchGeocodeOutcome = null;
        clearAllDistanceLines(listEl);
        setSearchHint(hintEl, false, '', null);
        restoreListOrderFromInitial(listEl);
        applyFilters(false);
        return;
      }
      if (!hasStoreGeoIndex()) {
        applyFilters(false);
        return;
      }
      ctx.userOrigin = null;
      ctx.searchGeocodeOutcome = null;
      setSearchHint(hintEl, false, '', null);
      applyFilters(false);
      scheduleSearchGeocode();
    }

    if (searchEl) {
      searchEl.addEventListener('input', onSearchInput);
    }
    if (filterRoot) {
      filterRoot.querySelectorAll('button[data-d1-sl-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-d1-sl-filter');
          if (!f) return;
          filterRoot.querySelectorAll('button[data-d1-sl-filter]').forEach(function (b) {
            var on = b.getAttribute('data-d1-sl-filter') === f;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.setAttribute('data-active', on ? 'true' : 'false');
          });
          applyFilters(true);
        });
      });
    }
    applyFilters(false);

    if (!data.apiKey || data.apiKey === '') {
      mapEl.setAttribute('data-state', 'no-key');
      return;
    }

    loadMapsApi(data.apiKey)
      .then(function () {
        // Paint the map immediately — don't wait on geocoding (all stores currently lack lat/lng).
        var center = { lat: -25.2744, lng: 133.7751 };
        var mapStyles = resolveMapStyles(data);
        var mapOpts = {
          zoom: 4,
          center: center,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
        };
        if (mapStyles && mapStyles.length) {
          mapOpts.styles = mapStyles;
        }
        var map = new google.maps.Map(mapEl, mapOpts);
        mapEl.removeAttribute('data-state');

        var bounds = new google.maps.LatLngBounds();
        var markers = [];
        var infoWindows = [];
        var markerIcon = makeAccentMarkerSymbol(google.maps, getSectionAccentColor(root));
        var markerZ =
          typeof google.maps.Marker.MAX_ZINDEX === 'number'
            ? google.maps.Marker.MAX_ZINDEX + 20
            : 1000;

        ctx.geocoder = new google.maps.Geocoder();
        ctx.idToLatLng = {};
        ctx.map = map;
        ctx.markers = markers;
        ctx.infoWindows = infoWindows;

        function addMarker(loc, position) {
          var latLng =
            position instanceof google.maps.LatLng
              ? position
              : new google.maps.LatLng(position.lat, position.lng);
          var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            title: loc.title,
            icon: markerIcon,
            zIndex: markerZ,
            optimized: false,
          });

          var phoneLine = '';
          if (loc.phone && String(loc.phone).trim()) {
            var th = escapeHtml(telHref(loc.phone));
            phoneLine =
              '<br/><a href="' +
              th +
              '">' +
              escapeHtml(String(loc.phone).trim()) +
              '</a>';
          }
          var iw = new google.maps.InfoWindow({
            content:
              '<div class="d1-sl-iw"><strong>' +
              escapeHtml(loc.title) +
              '</strong><br/>' +
              escapeHtml(loc.address) +
              phoneLine +
              '</div>',
          });

          marker.addListener('click', function () {
            infoWindows.forEach(function (w) {
              w.close();
            });
            iw.open({ map: map, anchor: marker });
            highlightListItem(listEl, String(loc.id));
          });

          markers.push({ marker: marker, id: String(loc.id), loc: loc });
          infoWindows.push(iw);
          bounds.extend(latLng);

          var lat = typeof latLng.lat === 'function' ? latLng.lat() : latLng.lat;
          var lng = typeof latLng.lng === 'function' ? latLng.lng() : latLng.lng;
          ctx.idToLatLng[String(loc.id)] = { lat: lat, lng: lng };
        }

        if (listEl) {
          [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item'), function (row, i) {
            if (row.getAttribute('data-initial-index') == null) {
              row.setAttribute('data-initial-index', String(i));
            }
          });
        }

        if (
          searchEl &&
          window.google &&
          window.google.maps &&
          window.google.maps.places
        ) {
          try {
            var ac = new google.maps.places.Autocomplete(searchEl, {
              fields: ['geometry', 'formatted_address', 'name'],
              componentRestrictions: { country: 'au' },
              types: ['geocode'],
            });
            ac.bindTo('bounds', map);
            ac.addListener('place_changed', function () {
              var place = ac.getPlace();
              if (!place.geometry || !place.geometry.location) {
                return;
              }
              var loc = place.geometry.location;
              var lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
              var lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
              clearTimeout(ctx.searchDebounce);
              ctx._skipInputReset = true;
              ctx.userOrigin = { lat: lat, lng: lng };
              ctx.searchGeocodeOutcome = 'ok';
              applyFilters(true);
            });
            ctx._placesAutocomplete = ac;
          } catch (e) {
            /* Places Autocomplete unavailable; Geocoder + debounce still work */
          }
        }

        if (listEl) {
          listEl.addEventListener('click', function (e) {
            var item = e.target.closest('.d1-store-locator__item');
            if (!item) return;
            if (e.target.closest('a')) return;
            if (item.hidden) return;
            var id = item.getAttribute('data-id');
            var found = markers.find(function (m) {
              return m.id === id;
            });
            if (!found || !found.marker.getMap()) return;
            var pos = found.marker.getPosition();
            map.panTo(pos);
            if (map.getZoom() < 14) {
              map.setZoom(15);
            }
            infoWindows.forEach(function (w) {
              w.close();
            });
            var idx = markers.indexOf(found);
            if (infoWindows[idx]) {
              infoWindows[idx].open({ map: map, anchor: found.marker });
            }
            highlightListItem(listEl, id);
          });
        }

        applyFilters(false);

        return Promise.all(
          data.locations.map(function (loc) {
            return geocodeLocation(ctx.geocoder, loc);
          })
        ).then(function (resolved) {
          var valid = resolved.filter(function (r) {
            return r.position;
          });
          if (!valid.length) {
            console.warn(
              'D1 Store Locator: No store coordinates resolved. Add lat/lng on store locations, or enable Geocoding API + billing for the Maps key.'
            );
            return;
          }
          valid.forEach(function (r) {
            addMarker(r.loc, r.position);
          });
          if (!bounds.isEmpty()) {
            map.fitBounds(bounds, { padding: 80 });
          }
          applyFilters(false);
          var qInit = (searchEl && (searchEl.value || '').trim()) || '';
          if (qInit.length >= MIN_GEO_CHARS) {
            scheduleSearchGeocode();
          }
        });
      })
      .catch(function () {
        mapEl.setAttribute('data-state', 'error');
      });
  }

  function highlightListItem(listEl, id) {
    if (!listEl) return;
    [].forEach.call(listEl.querySelectorAll('.d1-store-locator__item'), function (row) {
      if (row.getAttribute('data-id') === String(id)) {
        row.setAttribute('data-active', 'true');
      } else {
        row.removeAttribute('data-active');
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-d1-store-locator]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
